import { defineMessages } from '@sevenrooms/locales'

export const reservationAvailabilityMessages = defineMessages({
  resWidgetPerPersonLabel: {
    id: 'resWidgetPerPersonLabel',
    defaultMessage: 'person',
  },
  resWidgetPerReservationLabel: {
    id: 'resWidgetPerReservationLabel',
    defaultMessage: 'reservation',
  },
} as const)
